// extracted by mini-css-extract-plugin
export default {"melodyVideo":"PH-z","isFullWidth":"QH-z","landingPageVideo":"RH-z","play":"SH-z","iframeVideo":"TH-z","playHidden":"UH-z","fullwidth":"VH-z"};